import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-card-form',
  templateUrl: './login-card-form.component.html',
  styleUrls: ['./login-card-form.component.css']
})
export class LoginCardFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
